/// <amd-module name="Checks/ChecksOverview/ChecksIssuesMessageComponent" />
import React = require("react");
import { FeatureFlagConstants, ResourceTypeNames, TaskCheckConstants } from "Checks/ChecksOverview//Generated/Constants";
import { ChecksSource } from "Checks/ChecksOverview/ChecksSource";
import * as Resources from "Checks/ChecksOverview/Resources";
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";
import { CheckIssue, CheckIssueData, CheckIssueType } from "Checks/Client/Contracts/PipelinesChecks";
import { format } from "VSS/Core/Util/String";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IButtonProps } from "VSSUI/Button";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

export interface IChecksIssuesMessageComponentProps {
  resourceTypeName: string;
  resourceIds: string;
  checkIssue?: CheckIssue;
  complianceDeadline?: string;
}

export interface IChecksIssuesMessageComponentState {
  checkIssue?: CheckIssue;
  complianceDeadline?: string;
}

export class ChecksIssuesMessageComponent extends VssComponent<IChecksIssuesMessageComponentProps, IChecksIssuesMessageComponentState> {

  state = {
    checkIssue: undefined,
    complianceDeadline: undefined
  };

  constructor(props: IChecksIssuesMessageComponentProps, context: IVssComponentContext) {
    super(props, context);
    this._isDisableChecksFeatureEnabled = isFeatureFlagEnabled(context.pageContext, FeatureFlagConstants.EnableDisabledChecksFeature, false);
  }

  componentDidMount(): void {

    if (this.props.checkIssue) {
        return;
    }

    if (this.props.resourceTypeName === ResourceTypeNames.Environment) {
        const source = ChecksSource.getInstance(this.context.pageContext);
        const checkData = source.getData<PipelineChecksContracts.CheckData>
            ("ms.vss-pipelinechecks.checks-data-provider", {}) as PipelineChecksContracts.CheckData;
        if (checkData && Array.isArray(checkData.checkConfigurationDataList)) {

          let evaluatedCheckConfigurations: PipelineChecksContracts.CheckConfigurationData[];
          if (this._isDisableChecksFeatureEnabled){
            evaluatedCheckConfigurations = checkData.checkConfigurationDataList
              .filter(({ checkConfiguration }) => !checkConfiguration.isDisabled);
          }else{
            evaluatedCheckConfigurations = checkData.checkConfigurationDataList;
          }

          if (evaluatedCheckConfigurations && evaluatedCheckConfigurations.length > 0){
            let checkWithIssue = evaluatedCheckConfigurations
              .find(({ checkConfiguration }) => !!checkConfiguration.issue);
            if (checkWithIssue){
              this.setState({
                checkIssue: checkWithIssue.checkConfiguration.issue,
                complianceDeadline: checkData.defaultCheckSettings[TaskCheckConstants.TaskCheckScalabilityComplianceDeadline]
              });
            }
          }
        }
    } else {
        this.context.pageContext
          .getService<IVssContributionService>("IVssContributionService")
          .getDataAsync("ms.vss-pipelinechecks.checks-issues-provider", {
            resourceIds: this.props.resourceIds,
            resourceTypeName: this.props.resourceTypeName,
          })
          .then((checkIssueDataResult: CheckIssueData) => {
            if (checkIssueDataResult
                  && checkIssueDataResult.resourcesWithCheckIssuesList
                  && checkIssueDataResult.resourcesWithCheckIssuesList.length > 0 ) {
              this.setState({
                checkIssue: checkIssueDataResult.resourcesWithCheckIssuesList[0].checkIssue,
                complianceDeadline: checkIssueDataResult.defaultCheckIssueSettings[TaskCheckConstants.TaskCheckScalabilityComplianceDeadline]
              });
            }
          })
          .catch((err) => {
             console.error(err);
          });
    }
  }

  private getMessageCardSeverity(checkIssue?: CheckIssue){
    if (checkIssue){
      let checkIssueType = checkIssue.type;
      if (checkIssueType === CheckIssueType.Error){
        return MessageCardSeverity.Error;
      }else if (checkIssueType === CheckIssueType.Warning){
        return MessageCardSeverity.Warning;
      }
    }
    return MessageCardSeverity.Info;
  }

  render() {
    let checkIssue: CheckIssue | undefined;
    let complianceDeadline: string | undefined;
    if (this.props.checkIssue){
      checkIssue = this.props.checkIssue;
      complianceDeadline = this.props.complianceDeadline;
    }else{
      checkIssue = this.state.checkIssue;
      complianceDeadline = this.state.complianceDeadline;
    }

    const buttonProps: IButtonProps[] = [{
      onClick: this.onLearnMoreClicked,
      primary: false,
      text: Resources.ChecksIssueButton
    }];

    if (checkIssue) {
      return (
          <div className="page-content page-content-top">
              <MessageCard buttonProps={buttonProps} severity={this.getMessageCardSeverity(checkIssue)}>
                  { format(Resources.ChecksIssuesMessage, complianceDeadline) }
              </MessageCard>
          </div>
      );
    }
    return null;
  }

  private onLearnMoreClicked = () => {
    window.location.href = Resources.ChecksComplianceBlogPostLink;
  }

  private _isDisableChecksFeatureEnabled: boolean;
}

VssComponent.register("checks-issues-message", ChecksIssuesMessageComponent);
